import type { ErrorBoundaryFallbackProps } from "@suspensive/react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

export function PageErrorFallback({ error, reset }: ErrorBoundaryFallbackProps) {
  return (
    <Card className="mx-auto max-w-lg p-8 text-center">
      <div className="flex flex-col items-center gap-4">
        <AlertCircle className="h-12 w-12 text-destructive" />
        <h2 className="text-xl font-semibold">오류가 발생했습니다</h2>
        <p className="text-sm text-muted-foreground">{error.message}</p>
        <Button onClick={reset}>다시 시도</Button>
      </div>
    </Card>
  );
}

export function SectionErrorFallback({ error, reset }: ErrorBoundaryFallbackProps) {
  return (
    <div className="rounded-lg border p-6 text-center">
      <p className="text-destructive">{error.message}</p>
      <Button variant="outline" className="mt-4" onClick={reset}>
        다시 시도
      </Button>
    </div>
  );
}
